import styled from "styled-components";

const Body = styled.div`
  // background: red;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
`;

const Title = styled.div`
  // background: red;
  width: 280px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 30px;
  font-weight: 500;
  color: #464646;
  margin-top: 10px;
  text-align: center;
`;

const ContainerDescription = styled.div`
  // background: lightgray;
  width: 280px;
  font-size: 14px;
  color: #7676b6;
  margin-top: 10px;
  margin-bottom: 5px;
`;

const AccountContainer = styled.div`
  background: Aliceblue;
  border-radius: 6px;
  width: 280px;
  padding: 10px 20px;
  white-space: pre-line;
`;

const AccountRow = styled.div`
  // background: red;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  width: 100%;
`;

const EmptyResult = styled.div`
  // background: red;
  text-align: center;
  font-size: 18px;
`;

const SingleUsername = styled.div`
  // background: red;
  text-align: center;
  font-size: 18px;
`;

const ListUsername = styled.div`
  // background: red;
  // margin-left: 10px;
  text-align: left;
  font-size: 16px;
`;

const ResetPasswordButton = styled.button`
  // background: lightgray;
  // margin-right: 10px;
  white-space:nowrap;
`;

const Summary = styled.div`
  // background: red;
  text-align: center;
  margin-bottom: 5px;
  color: Slateblue;
`;

const StatusBar = styled.div`
// background: pink;
  box-sizing: border-box;  
  width: 280px;
  padding-top: 12px;
  padding-bottom: 10px;
  padding-left: 5px;
  // padding-right: 5px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
`;


const StatusTextButton = styled.div`
  color: blue;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  &:hover {
    background: lightgray;
  }
`;

export const FindAccountResult = ({
  accounts,
  onResetPassword,
  onBack,
  onClose,
}) => {
  if (accounts === null) return null;

  const parseAccount = account => {
    switch (account.type) {
      case 'local':
        return account.username;
      case 'oauth':
        return `${account.provider}로 가입한 계정`;
      default:
        throw new Error(`Unknown account type: ${account.type}`);
    }
  };

  return (
    <>
      <Body>
        <Title>아이디찾기</Title>
        <ContainerDescription>계정</ContainerDescription>
        
        <AccountContainer>
          {accounts.length === 0 && (
            <>
              <AccountRow>
                <EmptyResult>
                  입력하신 인증 정보로 가입된<br />
                  계정을 찾을 수 없습니다.<br />
                  인증정보를 확인해 주세요.
                </EmptyResult>
              </AccountRow>
            </>
          )}

          {accounts.length === 1 && (
            <>
              <AccountRow>
                <SingleUsername>{parseAccount(accounts[0])}</SingleUsername>
                {accounts[0].type === 'local' && (
                  <ResetPasswordButton onClick={() => onResetPassword(accounts[0])}>
                  비밀번호찾기
                  </ResetPasswordButton>
                )}
              </AccountRow>
            </>
          )}
          
          {accounts.length > 1 && (
            <>
              <Summary>* 총 {accounts.length}개의 계정을 찾았습니다.</Summary>
              {accounts.map((account, index) => (
                <AccountRow key={index}>
                  <ListUsername>{index + 1}. {parseAccount(account)}</ListUsername>
                  {account.type === 'local' && (
                    <ResetPasswordButton onClick={() => onResetPassword(account)}>
                      비밀번호찾기
                    </ResetPasswordButton>
                  )}
                </AccountRow>
              ))}
            </>
          )}
        </AccountContainer>

      </Body>
      <StatusBar>
          <StatusTextButton onClick={onClose}>종료</StatusTextButton>
          <StatusTextButton onClick={onBack}>뒤로</StatusTextButton>
      </StatusBar>
    </>      
  );
};